import {DI_TOKENS} from '@/di/di.tokens';

import {NavigateFunction} from 'react-router';
import {NavigateOptions} from 'react-router/lib/hooks';

import {injected} from 'brandi';

import {HTMLElementId} from '@/constants';
import {LoggerService} from '@/services/LoggerService/LoggerService';
import {PlatformService} from '@/services/PlatformService/PlatformService';
import {QueryStringService} from '@/services/QueryStringService/QueryStringService';
import {ClientRoutes, Envs, GlobalWindow} from '@/types';

export class NavigationService {
  private navigate: NavigateFunction | VoidFunction = () => {};
  private initialized: boolean = false;

  constructor(
    private readonly routes: ClientRoutes,
    private readonly globalWindow: GlobalWindow,
    private readonly platformService: PlatformService,
    private readonly queryStringService: QueryStringService,
    private readonly envs: Envs,
    private readonly loggerService: LoggerService,
  ) {}

  public setNavigate = (navigate: NavigateFunction): void => {
    if (this.initialized) return;

    this.navigate = navigate;
    this.initialized = true;
  };

  public navigateToAuthUserPage(options?: NavigateOptions): void {
    this.navigateTo(this.routes.AuthUser, options);
  }

  public navigateToMainPage(options?: NavigateOptions): void {
    this.navigateTo(this.routes.Main, options);
  }

  public navigateToMainPageForm(options?: NavigateOptions): void {
    this.navigateTo(`${this.routes.Main}#${HTMLElementId.Form}`, options);
  }

  public navigateToClickerGamePage(options?: NavigateOptions): void {
    this.navigateTo(this.routes.ClickerGame, options);
  }

  public navigateToResultsPage(options?: NavigateOptions): void {
    this.navigateTo(this.routes.Results, options);
  }

  public authPageReloadWithoutQueryRef = (): void => {
    this.globalWindow.location.href =
      this.envs.APP_PROJECT_URL + this.routes.AuthUser + this.queryStringService.getQueryWithoutRefId();
  };

  public pageReload = (): void => {
    // параметр 0 служит для перезагрузки страницы
    // берет из истории последний добавленный элемент
    this.navigate(0);
  };

  public pageAppReload = (): void => {
    this.globalWindow.location.href =
      this.envs.APP_PROJECT_URL + `?auth=true&${this.platformService.getAppQueryString()}`;
  };

  public navigateTo(link: string, options?: NavigateOptions): void {
    this.navigate(link, options);
  }

  public openLink(link: string): void {
    if (link.startsWith('tcsgames')) {
      this.globalWindow.open(link);
    } else {
      // Иначе это диплинк открываем как обычную внешнюю ссылку
      this.externalNavigate(link);
    }
  }

  public externalNavigate(link: string): void {
    this.globalWindow.open(link, '_blank', 'noopener noreferrer');
  }
}

injected(
  NavigationService,
  DI_TOKENS.clientRoutes,
  DI_TOKENS.globalWindow,
  DI_TOKENS.platformService,
  DI_TOKENS.queryStringService,
  DI_TOKENS.envs,
  DI_TOKENS.loggerService,
);
